import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import { Link, Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@mui/material';

import { ClientInvitationFragment } from 'api';
import { ResponsiveTable } from 'components';
import { InfiniteQuery } from 'types/app';
import { generateLink } from 'Links';
import { getFullName } from 'helpers';

import AcceptedTableLoader from './AcceptedTableLoader';

const AdminAcceptedInvitationsTable: FC<InfiniteQuery<ClientInvitationFragment>> = ({
  sentinelRef,
  results,
  isExhausted,
  isInitialLoad,
}) => {
  const { t } = useTranslation();

  return (
    <ResponsiveTable>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>{t('common:name')}</TableCell>
            <TableCell>{t('common:email')}</TableCell>
            <TableCell>{t('admin:role')}</TableCell>
            <TableCell>{t('admin:invitedBy')}</TableCell>
            <TableCell>{t('common:sent')}</TableCell>
            <TableCell>{t('common:accepted')}</TableCell>
            <TableCell>{t('common:status')}</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {isInitialLoad && <AcceptedTableLoader sentinelRef={null} rows={8} />}
          {results.map(result => (
            <TableRow key={result.id}>
              <TableCell>
                <Link
                  variant="body1"
                  component={generateLink(`/profile/${result.accepted_by_user?.id}`)}
                  underline="hover"
                >
                  {getFullName(result.accepted_by_user)}
                </Link>
              </TableCell>
              <TableCell>{result.email_address}</TableCell>
              <TableCell>{result.user_type}</TableCell>
              <TableCell>
                <Link
                  variant="body1"
                  component={generateLink(`/profile/${result.added_by_user?.id}`)}
                  underline="hover"
                >
                  {getFullName(result.added_by_user)}
                </Link>
              </TableCell>
              <TableCell>
                <Typography title={moment.unix(result.created_at).format('l')}>
                  {moment.unix(result.created_at).format('l')}
                </Typography>
              </TableCell>
              <TableCell>
                <Typography title={moment.unix(result.accepted_at).format('l')}>
                  {moment.unix(result.accepted_at).format('l')}
                </Typography>
              </TableCell>
              <TableCell>
                {result.accepted_by_user?.onboarding_completed ? 'Active' : 'Onboarding'}
              </TableCell>
            </TableRow>
          ))}
          {!isExhausted && <AcceptedTableLoader sentinelRef={sentinelRef} rows={1} />}
        </TableBody>
      </Table>
    </ResponsiveTable>
  );
};

export default AdminAcceptedInvitationsTable;
